import _ from 'lodash'
import { getBooleanVal, getObjVal, isEmpty } from '../utils'
import { getObjValues } from '../redux/stateUtils'
import { isAdult } from './guestLogic'
import { guestTypes } from '../constants/guestConstants'
import { ILM } from '../constants/programConstants'

/**
 * Returns price per day for a single room with specified number of guests
 */
export function getPriceForRoom(
  pricesFromState,
  roomType,
  numAdults = 0,
  numKids = 0,
  guestCount,
  oneRoomSelected,
  fromUI
) {
  if (!pricesFromState || pricesFromState.length === 0) {
    return 0
  }
  let totalGuests = numAdults + numKids
  if (roomType === 'Lodge') {
    if (numAdults === 1) {
      let roomPriceObj = _.find(pricesFromState, {
        roomType: 'LODGE',
        guestType: 'ADULTS',
        quantity: 1
      })
      return roomPriceObj.price
    } else if (numKids === 1) {
      let roomPriceObj = _.find(pricesFromState, {
        roomType: 'LODGE',
        guestType: 'KIDS',
        quantity: 1
      })
      return roomPriceObj.price
    } else if (numKids === 0 && numKids === 0) {
      let roomPriceObj = _.find(pricesFromState, {
        roomType: 'LODGE',
        guestType: 'ADULTS',
        quantity: 1
      })
      return roomPriceObj.price
    }
  } else if (roomType === 'Studio') {
    if (numAdults === 0 && (guestCount && numKids === guestCount)) {
      if (fromUI) {
      } else {
        throw new Error('A studio must have at least one adult in it')
      }
    }
    let costForKids = 0
    let costForAdults = 0
    let adultRoomPriceObj = _.find(pricesFromState, {
      roomType: 'STUDIO',
      guestType: 'ADULTS',
      quantity: numAdults
    })
    let kidsRoomPriceObj = _.find(pricesFromState, {
      roomType: 'STUDIO',
      guestType: 'KIDS',
      quantity: numKids
    })
    if (kidsRoomPriceObj) {
      costForKids = kidsRoomPriceObj.price
    } else {
      kidsRoomPriceObj = _.find(pricesFromState, {
        roomType: 'STUDIO',
        guestType: 'KIDS',
        quantity: 1
      })
      costForKids = kidsRoomPriceObj.price * numKids
    }

    if (adultRoomPriceObj) {
      costForAdults = adultRoomPriceObj.price ? adultRoomPriceObj.price : 0
    }
    return costForAdults + costForKids
  } else if (roomType === 'Queen Suite') {
    if (
      numAdults === 0 &&
      (guestCount && totalGuests == guestCount) &&
      oneRoomSelected
    ) {
      if (fromUI) {
        // dispatch(populateFormErrors({message: 'A suite must have at least one adult in it'}))
      } else {
        throw new Error('A suite must have at least one adult in it')
      }
    }
    let roomPriceObj = _.find(pricesFromState, { roomType: 'QUEEN_SUITE' })
    return roomPriceObj.price
  } else if (roomType === 'King Suite') {
    if (
      numAdults === 0 &&
      (guestCount && totalGuests == guestCount) &&
      oneRoomSelected
    ) {
      if (fromUI) {
        // dispatch(populateFormErrors({message: 'A studio must have at least one adult in it'}))
      } else {
        throw new Error('A studio must have at least one adult in it')
      }
    }
    let roomPriceObj = _.find(pricesFromState, {
      roomType: 'KING_SUITE',
      quantity: numAdults
    })
    return roomPriceObj.price
  } else if (roomType === 'Mahima Stay') {
    let adultPrice =
      numAdults > 0
        ? _.find(pricesFromState, {
            roomType: 'MAHIMA_STAY',
            guestType: 'ADULTS',
            quantity: numAdults
          }).price
        : 0

    let childPrice =
      numKids > 0
        ? _.find(pricesFromState, {
            roomType: 'MAHIMA_STAY',
            guestType: 'KIDS',
            quantity: numKids
          }).price
        : 0

    return adultPrice + childPrice
  } else {
    // Generic room pricing handling

    const pricingRoomType = roomType.toUpperCase()
    const adultPriceObject =
      numAdults > 0
        ? _.find(pricesFromState, {
            roomType: pricingRoomType,
            guestType: 'ADULTS',
            quantity: numAdults
          })
        : 0

    const childPriceObject =
      numKids > 0
        ? _.find(pricesFromState, {
            roomType: pricingRoomType,
            guestType: 'KIDS',
            quantity: numKids
          })
        : 0

    if (!adultPriceObject && !childPriceObject) {
      throw new Error('Unknown room type: ' + roomType)
    }

    let price = 0
    if (adultPriceObject) {
      price += adultPriceObject.price
    }

    if (childPriceObject) {
      price += childPriceObject.price
    }

    return price
  }
}

/**
 * "Young Adult" guests are treated as adults as far as pricing is concerned
 * @param type
 * @returns {string}
 */
function getGuestTypeForPricing(type) {
  return !type || isAdult(type) ? guestTypes.adult : guestTypes.child
}

export function getPriceForRoomObject(
  pricesFromState,
  room,
  guestInfoList,
  guestCount,
  fromUI,
  guestDetails,
  dispatch
) {
  guestInfoList = getObjValues(guestInfoList)
  let guestSummary = {}
  if (!room || !room.id || room.id === '') return 0
  if (fromUI || (guestDetails && guestDetails.length > 0)) {
    // While populating the form in UI the complete room details will not be populated until the form gets submitted
    // So this logic will get the guest details from guestDetails object
    let guests = _.filter(guestDetails, { room: { value: room.id } })
    guestSummary = _(guests)
      .groupBy(guest => getGuestTypeForPricing(guest.guestType.value))
      .mapValues(guests => guests.length)
      .value()

    if (!guestSummary.adult) {
      guestSummary.adult = 0
    }
    if (!guestSummary.child) guestSummary.child = 0
  } else {
    guestSummary = _(guestInfoList)
      .groupBy(guest => getGuestTypeForPricing(guest.guestType))
      .mapValues(guests => guests.length)
      .value()
  }
  if (guestSummary[undefined]) delete guestSummary[undefined]
  if (isEmpty(guestSummary)) return 0

  let oneRoomSelected = _.find(guestDetails, guest => {
    return !isEmpty(getObjVal(guest.room))
  })

  // While form is being filled out, there may be no adults or children assigned
  // to that room. In that case, show price for 1 adult
  if (guestSummary.adult === 0 && guestSummary.child === 0) {
    guestSummary.adult = 1
  }

  return getPriceForRoom(
    pricesFromState,
    room.type,
    guestSummary.adult || 0,
    guestSummary.child || 0,
    guestCount,
    oneRoomSelected,
    fromUI,
    guestDetails,
    dispatch
  )
}

/**
 * Returns total price per day for all rooms selected
 */
export function getPriceFromSelections(
  pricesFromState,
  selections,
  rooms,
  prevPage,
  fromUI,
  guestDetails,
  dispatch,
  program
) {
  if (!pricesFromState || pricesFromState.length === 0) {
    return 0
  }
  let pricePerDay = _(selections)
    .map(selection => {
      return _(selection.rooms)
        .map(room => {
          if (getBooleanVal(room.useCustomPrice)) {
            return parseFloat(room.customPrice)
          } else if (room.roomId) {
            const priceForRoom = getPriceForRoomObject(
              pricesFromState,
              rooms[getObjVal(room.roomId)],
              room.guests,
              room.numGuests,
              fromUI,
              guestDetails,
              dispatch
            )
            return priceForRoom
          } else {
            return 0
          }
        })
        .sum()
    })
    .flatten()
    .sum()

  return pricePerDay
}



// WEBPACK FOOTER //
// ./src/logic/pricingLogic.js